import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const Vue_Vuex = new Vuex.Store({
  state: {
    Load: true,
    Config: {
      Language: [
        {Code: "zh-CN", Name: "中文(简体)"}
      ]
    },
    LanguageText: null,
    Language: 0,
    UserInfo: null,
    Api: {
      Index: "Api/Index.php",
      Captcha: "Api/Captcha/Captcha.php",
      Admin: {
        Index: "Api/Admin/Index.php",
        Server: {
          Delete: "Api/Admin/Server/Delete.php",
          Edit: "Api/Admin/Server/Edit.php",
          List: "Api/Admin/Server/List.php"
        },
        Advertise: {
          Add: "Api/Admin/Advertise/Add.php",
          Delete: "Api/Admin/Advertise/Delete.php",
          Edit: "Api/Admin/Advertise/Edit.php",
          List: "Api/Admin/Advertise/List.php"
        },
        Tag: {
          Add: "Api/Admin/Tag/Add.php",
          Delete: "Api/Admin/Tag/Delete.php",
          Edit: "Api/Admin/Tag/Edit.php",
          List: "Api/Admin/Tag/List.php"
        },
        User: {
          Ban: "Api/Admin/User/Ban.php",
          Delete: "Api/Admin/User/Delete.php",
          List: "Api/Admin/User/List.php",
          UnBan: "Api/Admin/User/UnBan.php"
        },
        Web: {
          Edit: "Api/Admin/Web/Edit.php",
          List: "Api/Admin/Web/List.php"
        }
      },
      Server: {
        Add: "Api/Server/Add.php",
        Delete: "Api/Server/Delete.php",
        Edit: "Api/Server/Edit.php",
        Info: "Api/Server/Info.php",
        List: "Api/Server/List.php",
        StartMonitor: "Api/Server/StartMonitor.php",
        Vote: "Api/Server/Vote.php"
      },
      User: {
        ChangePassword: "Api/User/ChangePassword.php",
        EmailVerify: "Api/User/EmailVerify.php",
        Info: "Api/User/Info.php",
        Login: "Api/User/Login.php",
        LoginOut: "Api/User/LoginOut.php",
        Register: "Api/User/Register.php",
        ReSendEmailVerify: "Api/User/ReSendEmailVerify.php",
        ResetPassword: "Api/User/ResetPassword.php"
      }
    }
  },
  mutations: {
    Config(State, Data) {
      State.Config = Data
    },
    UserInfo(State, Data) {
      State.UserInfo = Data
      State.Load = false
    },
    Language(State, Data) {
      State.Language = Data
    },
    LanguageText(State, Data) {
      State.LanguageText = Data
    }
  }
})

export default Vue_Vuex
